import UnitInviteApplicantsModalContainer from "./UnitInviteApplicantsModalContainer";

export default UnitInviteApplicantsModalContainer;
